import { useAdminStore } from '../stores/useAdminStore';
import { useViewerModeStore } from '../stores/useViewerModeStore';
import { useResponsiveDesign } from './useResponsiveDesign';

export const useAdminVisible = (): boolean => {
  const isAdminMode = useAdminStore(s => s.isAdminMode);
  const mode = useViewerModeStore(s => s.mode);
  const { isMobile } = useResponsiveDesign();
  return isAdminMode && !isMobile && mode === 'personal';
};
